import Vue from 'vue';

export default {
  state: {
    user: null,
  },
  getters: {
    USER: state => {
      return state.user;
    },
  },
  mutations: {
    SET_USER: (state, payload) => {
      state.user = payload;

      Vue.axios.interceptors.request.use(config => {
        config.headers['X-Auth-Token'] = state.user ? state.user.api_token : '';
        return config;
      });
    },
  },
  actions: {
    INIT_USER: (context) => {
      context.commit('SET_USER',
          localStorage.getItem('user')
              ? JSON.parse(localStorage.getItem('user'))
              : null);
    },
    SET_USER: (context, user) => {
      context.commit('SET_USER', user);
    },
  },
};